<template lang="pug">
    .tasks-list-item(v-if="$props.task")
        .tasks-list-item__header
            .tasks-list-item__header-left
                .tasks-list-item__header-project.chip.chip-default {{($props.task.project) ? $props.task.project.name : ''}}
                router-link(v-bind:to="{ name: 'Task', params: { projectid: (!$props.task.project_id ? 'all' : $props.task.project_id), taskid: $props.task.id }, query: $route.query }").tasks-list-item__header-title(v-bind:title="$props.task.name") {{($props.task.name) ? $props.task.name : ''}}
            .tasks-list-item__header-right
                .tasks-list-item__header-actions(v-if="$props.task.id")
                    md-button.md-icon-button.md-dense.small(@click.stop="openDeleteDialog()"): md-icon delete
                    
        .tasks-list-item__body
            .tasks-list-item__body-description {{($props.task.description) ? $props.task.description : ''}}

        .tasks-list-item__footer
            .tasks-list-item__footer-left
                .tasks-list-item__footer-item.tasks-list-item__footer-status {{ ($props.task.status_section) ? $props.task.status_section.name : 'Не установлен' }}
                .tasks-list-item__footer-item.tasks-list-item__footer-deadline {{ deadline }}
                .tasks-list-item__footer-item.tasks-list-item__footer-waste-time(v-if="wasteTime") {{wasteTime.days + 'дн, ' + wasteTime.hours + 'ч, ' + wasteTime.days + 'мин'}}
                .tasks-list-item__footer-item.tasks-list-item__footer-taskmaster
                    .chip.chip-gray {{($props.task.taskmaster) ? (($props.task.taskmaster.fio) ? $props.task.taskmaster.fio : $props.task.taskmaster.login ) : ''}}
                
            .tasks-list-item__footer-center
                
            .tasks-list-item__footer-right
                .tasks-list-item__footer-item.tasks-list-item__footer-responsibles(v-if="responsibles")
                    .tasks-list-item__footer-responsible.chip.chip-gray(v-for="user in responsibles" v-bind:key="user.id") {{(user.fio) ? user.fio : user.login }}
                .tasks-list-item__footer-item.tasks-list-item__footer-checklist(v-if="checklist")
                    span.icon: i.far.fa-check-square
                    span {{checklist.completed + '/' + checklist.all}}

        md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
            md-dialog-title Удалить задачу?
            md-dialog-actions
                md-button.md-primary(@click="closeDeleteDialog") Отмена
                md-button.md-primary(@click="deleteTask()") Удалить
</template>
<script>
  import moment from "moment"
  export default {
    name: 'tasks-list',
    props: {
        task: {
            type: Object,
            default: {}
        }
    },
    data() {
      return {
        deleteDialog: false
      }
    },
    created() {
    },
    watch: {
    },
    computed: {
        responsibles() {
            let result = [], ids = [];
            if (!this.$props.task) return result;
            if (this.$props.task.responsible) {
                ids.push(this.$props.task.responsible.id);
                result.push(this.$props.task.responsible);
            }
            if (this.$props.task.coexecutor && this.$props.task.coexecutor.length) {
                this.$props.task.coexecutor.map(user => {
                    if (!(ids.indexOf(user.id)+1)) {
                        ids.push(user.id);
                        result.push(user);
                    }
                });
            }
            return result;
        },
        deadline() {
            if (!this.$props.task || !this.$props.task.deadline) return;
            return moment(this.$props.task.deadline).calendar();
        },
        wasteTime() {
            let time = {minutes: 0, hours: 0, days: 0, minutes: 0};
            if (!this.$props.task.id || !this.$props.task.time || !this.$props.task.time.wasted_time || parseInt(this.$props.task.time.wasted_time) <= 0) return time; 
                time.minutes = Math.floor(this.$props.task.time.wasted_time);
                time.hours   = Math.floor(time.minutes/60);
                time.days    = Math.floor(time.hours/8);
                time.hours   = time.hours   - (time.days * 8);
                time.minutes = time.minutes - (time.hours * 60) - (time.days * 8 * 60);

            return time;
        },
        checklist() {
            if (!this.$props.task.checklist || !this.$props.task.checklist.length) return;
            let result = {
                all: 0,
                completed: 0
            };
            this.$props.task.checklist.map(section => {
                if (section.i && section.i.length) section.i.map(check => {
                    result.all++;
                    if (check.c) result.completed++;
                });
            });
            return result;
        }
    },
    methods: {
        openDeleteDialog() {
            this.deleteDialog = true;
        },
        closeDeleteDialog() {
            this.deleteDialog = false;
        },
        deleteTask() {
            this.deleteDialog = false;
            return this.$store.dispatch('tasks/deleteTask', {task_id: this.$props.task.id});
        }
    }
  }
</script>
<style scoped lang="sass">
    .tasks-list-item
        border-bottom: 1px solid rgba(0, 0, 0, 0.12)
        padding: 5px
        min-width: 900px
        overflow-x: hidden
        &:hover
            background: #eee
            .tasks-list-item__header
                .tasks-list-item__header-actions
                    visibility: visible
                    width: auto
                    opacity: 1
        .chip
            padding: 2px 6px
            font-size: 12px
            line-height: 14px
            display: flex
            align-items: center
            justify-content: center
            border-radius: 4px
        .chip-default
            background-color: var(--md-theme-default-primary, #2196f3)
            color: #fff
        .chip-gray
            background-color: #dadada
        .tasks-list-item__header
            display: flex
            align-items: center
            justify-content: flex-start
            width: 100%
            overflow: hidden
            .tasks-list-item__header-left
                display: flex
                align-items: center
                justify-content: flex-start
                width: calc(100% - 120px)
            .tasks-list-item__header-project
                max-width: 150px
                margin: 0 10px 0 0
                flex-shrink: 0
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
            .tasks-list-item__header-title
                max-width: 100%
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                font-size: 14px
                line-height: 14px
            .tasks-list-item__header-right
                width: auto
                flex-shrink: 0
                margin: 0 0 0 auto
            .tasks-list-item__header-deadline
                font-size: 14px
                line-height: 14px
            .tasks-list-item__header-actions
                visibility: hidden
                width: 0px
                padding: 0px
                margin: 0px
                opacity: 0
                transition: 0.45s
        .tasks-list-item__body
            padding: 4px 0
            .tasks-list-item__body-description
        
        .tasks-list-item__footer
            display: flex
            align-items: center
            justify-content: space-between
            .tasks-list-item__footer-item
                width: 120px
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                .icon
                    margin: 0 5px 0 0
                &.tasks-list-item__footer-deadline 
                    width: 150px
            .tasks-list-item__footer-left
                display: flex
                align-items: center
                justify-content: flex-start
            .tasks-list-item__footer-responsibles
                display: flex
                align-items: center
                justify-content: flex-start
                width: auto
            .tasks-list-item__footer-responsible
                margin: 0 4px 0 0
            .tasks-list-item__footer-checklist
                width: auto
                margin: 0 0 0 6px
            .tasks-list-item__footer-taskmaster
                width: auto
                display: flex
                align-items: center
                justify-content: flex-start

            .tasks-list-item__footer-right
                display: flex
                align-items: center
                justify-content: flex-start
            .tasks-list-item__footer-status

</style>



// WEBPACK FOOTER //
// TasksListItem.vue?07c9ea46